<template>
  <b-container>
    <h3 class="mb-4">Vehicles Uploads</h3>
    <SharedTable
      :fields="fields"
      :items="items"
      :options="options"
      :busy="loading"
      @getSelectedItems="getSelectedItems"
    >
    </SharedTable>
  </b-container>
</template>

<script>
import SharedTable from "@/modules/shared/table.vue";
import { GET_VEHICLES_UPLOADED } from "./actions";

export default {
  name: "VehiclesUploadedTable",
  components: {
    SharedTable,
  },
  data() {
    return {
      loading: false,
      filter: null,
      fields: [
        {
          key: "vin",
          label: "VIN Number",
          sortable: true,
        },

        {
          key: "year",
          label: "Year",
          sortable: true,
        },
        {
          key: "make",
          label: "Make",
          sortable: true,
        },
        {
          key: "model",
          label: "Model",
          sortable: true,
        },
        {
          key: "color",
          label: "Color",
          sortable: true,
        },
        {
          key: "trim",
          label: "Trim",
          sortable: true,
        },
        {
          key: "series",
          label: "Series",
          sortable: true,
        },

        {
          key: "date",
          label: "Date",
          sortable: true,
        },
      ],
      options: {
        fun: this.refreshData,
      },
      selectedItems: [],
      items: {
        data: [],
        total: 0,
        currentPage: 1,
        perPage: 10,
      },
    };
  },
  computed: {
    // Add any Vuex state mappings if needed
  },
  methods: {
    async refreshData() {
      this.getData();
    },
    async getData(filter = null, page = 1) {
      this.loading = true;
      try {
        this.$store
          .dispatch(GET_VEHICLES_UPLOADED, {
            id: this.$route.params.id,
            search: filter,
            page: page,
          })
          .then((response) => {
            this.items.data = response.data;
            this.items.total = response.total;
            this.loading = false;
          })
          .catch((error) => {
            console.error("Error fetching vehicles:", error);
            this.loading = false;
          });
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        this.loading = false;
      }
    },

    getSelectedItems(items) {
      this.selectedItems = items;
    },
    changePage(page) {
      this.getData(this.filter, page);
    },
    editItem(item) {
      // Implement edit functionality
      console.log("Edit item:", item);
    },
    deleteItem(item) {
      // Implement delete functionality
      console.log("Delete item:", item);
    },
    activateItem(item) {
      // Implement activate functionality
      console.log("Activate item:", item);
    },
    updateItem(item) {
      // Implement update functionality
      console.log("Update item:", item);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.btn-primary {
  background-color: #0277bc;
}
</style>
